import React from "react";
import SignUp from "./forms/ConfirmPassword/ConfirmPassword";
import ResetPassword from "./forms/ResetPassword/ResetPassword";
import { formTypes } from "./utils/constants";
import LogIn from "./forms/LogIn/LogIn";
import Logo from "common/components/Logo/Logo";
import "./Authentication.less";
import { useDispatch, useSelector } from "react-redux";
import { rootReducerType } from "redux/combineReducers";
import { setCurrentFormStep } from "redux/authentication/actions";

const Authentication: React.FC = () => {

	const dispatch = useDispatch();

	const { current_form } = useSelector(
		(state: rootReducerType) => state.authenticationReducer
	);

	const updateFormType = (type: string) => {
		dispatch(
			setCurrentFormStep({
				current_form: type
			})
		);
	};

	const renderForm = () => {
		switch (formTypes[current_form].type) {
			case "sign-in":
				return <LogIn updateFormType={updateFormType} />;
			case "reset-password":
				return <ResetPassword updateFormType={updateFormType} />;
			case "sign-up":
				return <SignUp updateFormType={updateFormType} />;
			default:
				return null;
		}
	};

	return (
		formTypes[current_form] ? <section className="authentication-container">
			<img
				alt="logo"
				src={require("../../assets/login-image.png")}
			/>
			<Logo />

			<section className="auth-details-container">

				<section className="auth-details">
					<div className="title">
						{formTypes[current_form].title}</div>
					<div className="subtitle">{formTypes[current_form].subtitle}</div>
					{renderForm()}
					<div className="credits">© 2025 By P.D. McLaren Ltd.</div>
				</section>
			</section>
		</section> : null

	);
};

export default Authentication;
